import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { DocxExporterService } from '../../services/docx-exporter.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { ModelliStampaService } from '../../services/modelli-stampa.service';
import { Utenteservice } from '../../services/utente.service';
import { EditAutocompleteComponent } from '../edit-autocomplete/edit-autocomplete.component';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
import dxTagBox from 'devextreme/ui/tag_box';


function isNotEmpty(value: any): boolean {
  return value !== undefined && value !== null && value !== '';
} 
let  that;
@Component({
  selector: 'app-giacenzerifiuti',
  templateUrl: './giacenzerifiuti.component.html',
  styleUrls: ['./giacenzerifiuti.component.css']
})
export class GiacenzerifiutiComponent implements OnInit,AfterViewInit {
  @ViewChild('sede', { static: false }) sede: EditAutocompleteComponent;
  @ViewChild('magazzino', { static: false }) magazzino: EditAutocompleteComponent;  
  @ViewChild('soggetto', { static: false }) soggetto: EditAutocompleteComponent;  
  @ViewChild('formGiacenze', { static: false }) formGiacenze: NicaAnagraficaComponent; 
  @ViewChild('posizioniTagBox', { static: false }) posizioniTagBox: dxTagBox;  

  @ViewChild('dynamicHtml', { static: false, read: ViewContainerRef }) dynamicHtml: ViewContainerRef;


//  @ViewChild('dataContainer', { static: true, read: ViewContainerRef }) dataContainer: ViewContainerRef;
//  @ViewChild('dataContainer',{static:true}) divBinder: ElementRef<HTMLElement>;
  buttonOptions:any;
  employees: string[];
  dataSource: any;
  dtInserimento:string='31-12-2023'
  @Input() api: string='cer'; 
  @Input() key: string='id'; 
  magazzini:any;
  myfilter: string="?load=true";
  myfilterFlag:boolean=false;
  myfilterDett:string='';
  isFromMenu:boolean=true;
  currentSede;
  currentData;
  currentMagazzini;
  currentPosizioni;
  posizioni;

  initialQuery:boolean=true;
  currentSoggetto;
 
  showDynamicPopOver=false;
  now: Date = new Date();
  Data = new Date();
  DettagliaRiferimenti:boolean=false;



  hireDateEditorOptions: Object;
  theHtmlString: any;
  safeHtml: any;
  currentRowData = null;  
  popupVisible: boolean=false;
  closeButtonOptions: { text: string; onClick(e: any): void; };
  emailButtonOptions: { icon: string; text: string; onClick(e: any): void; };
  //that: this;
  jsonProtocolli=[
    {
    id:1,
    quantita:100,
    protocollo:"AB1"
  },
  {
    id:2,
    quantita:200,
    protocollo:"AB2"
  },
  {
    id:3,
    quantita:300,
    protocollo:"AB3"
  },
]
  constructor(
    private sanitizer: DomSanitizer,
    private httpClient: HttpClient,
    private _overlaySideFormService: OverlaySideFormService,
    private _overlaySidePanelService: OverlaySideFormService,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private spinner: NgxSpinnerService,
    private userComponentService: ComponentService, private appService: Apiservice, private http: HttpClient, private dati: FormsTemplateService, private cdref: ChangeDetectorRef, private componentFactoryResolver: ComponentFactoryResolver,
    private activatedroute: ActivatedRoute, private docxExporterService: DocxExporterService, private httpBackend: HttpBackend, private utenteSerivce: Utenteservice,private modelliStampaService:ModelliStampaService    
  ) {

    that=this;
    
    this.appService.GetApi('PosizioneRifiuti').then(result=>{
      this.currentPosizioni=[];
      this.posizioni=result['items'];
      //this.CalcoloQuery();
    })
this.buttonOptions = {
  text: "Do Something",
  
  onClick: function () {
      // Implement your logic here
  }
};

    this.emailButtonOptions = {
      icon: 'save',
      text: 'Salva',
      onClick(e) {
        const message = `Protocolli aggiunti correttamente`;
        that.popupVisible = false;
        notify({
          message,
          position: {
            my: 'center top',
            at: 'center top',
          },
        }, 'success', 3000);
      },
    };
    this.closeButtonOptions = {
      text: 'Chiudi',
      onClick(e) {
        that.popupVisible = false;
      },
    };
    
    this.hireDateEditorOptions = { width: '100%', value: null };
    
   // this.sede.containerComponent=this;
   // this.magazzino.containerComponent=this;
   this.theHtmlString='<dx-button  stylingMode="contained" text="Contained1"  type="normal" [width]="120"></dx-button>';

   }//end constructor
   optionalButton(e){
   // alert(e.name)
    this.popupVisible=true;
   }
   AllEvent(e){
    //onEditorPrepared
    if(e.name=='onEditorPrepared'){    
      console.log("onEditorPrepared ",e.masterThis)
        e.masterThis.settaField('idcer',e.data.cer)
        //e.masterThis.changeStateField(['idStatoFisico','idTipoCarico','riferimentoCER'],true)
        //idStatoFisico

    }
    if(e.name=='setCellValue'){
      console.log("Dovrei settare ",e)
      if(e.dataField=='cer'){
        setTimeout(() => {
          e.masterThis.settaField('idcer',e.value)
          
        }, 5);
      }
    }
    //
    if(e.name=='onInitNewRow'){
      
      console.log("onInitNewRow in Component ",e)
      setTimeout(() => {
        e.masterComponent.changeStateField(['cer','idStatoFisico','idTipoCarico','riferimentoCER'],false)
        
      }, 200);

     /* if (this.currentRowData) {  
        this.currentRowData.idTipoCarico=null;
        this.currentRowData.riferimentoCER=null;
        this.currentRowData.volumeMC=null;
        this.currentRowData.protocollo=null;
        this.currentRowData.idStatoFisico=null;
        e.data = this.currentRowData;  
    }  */      
      this.currentRowData=null
   }

    if(e.name=='onSaved'){
      console.log("OnSaved in Component ",e)
            
      
      //this.formGiacenze.griglia.instance.addRow();
      //this.formSchedaRifiuto.settaField('idSedeProduttore',ev.data.idSedeProduttore)
   }
    if(e.name=='onSaving'){
      console.log("OnSaving in Component ",e)
      //this.currentRowData=e.changes[0].data

      //delete e.changes[0].data['idcer']
      
      //delete thisIsObject[key]; 
     // this.formGiacenze.griglia.instance.addRow();
      //this.formSchedaRifiuto.settaField('idSedeProduttore',ev.data.idSedeProduttore)
   }
  }
   validateDataFieldPrepared(e){
    
   }
  ngAfterViewInit(): void {
    //this.theHtmlString='<dx-button  stylingMode="contained" text="Contained1"  type="normal" [width]="120"></dx-button>';
 
    this.sede.containerComponent=this;
    this.magazzino.containerComponent=this;
    //this.soggetto.containerComponent=this;
  }

     
    SedeChanged(e) {
     
      //console.log("SedeChanged ",e)   
      //alert("cambiatooooooooo",'cambiato')
      this.myfilter='?load=true';
      this.myfilterFlag=false;
      this.myfilterDett='';
      if(e==null){
        this.currentMagazzini=[];
        this.magazzini=[];
        return;
      }
      //alert(e.id)
     // console.log(this.magazziniTagBox)
      //this.magazziniTagBox.resetOption('selectedItems');
      //selectedItems
      this.currentSede=e.id;  
      this.appService.GetApi('MagazzinoRifiuti?idSede='+e.id).then(result=>{
        //console.log("Ecco i magazzini ",result)
        this.currentMagazzini=[];
        this.magazzini=result['items']
              
        //this.CalcoloQuery();
      })
    }


   
  MagazzinoChanged(e) {
    console.log("MagazzinoChanged ",e)
    let idMagaz=0
    let sede=0;
    let magazzino=0;
    if(e==null){
      this.formGiacenze.aggiungi=false
      sede=0;
      idMagaz=0;
    }else{
    //id: 4, idSede: 4
    sede=e.idSede;
    magazzino=e.id    
    this.formGiacenze.aggiungi=true
    }
    this.formGiacenze.costantValues=[
      {key:'IdDestinatario',value:sede},
      {key:'IdMagazzino',value:magazzino}      
    ]    
    this.formGiacenze.filter="?IdDestinatario="+sede+"&IdMagazzino="+magazzino
    this.formGiacenze.refresh();

  }
  SoggettoChanged(e) {
    console.log("SoggettoChanged ",e)

  }
  ngOnInit() {

  
  }
  PosizioniChangedList(e){
    this.currentPosizioni=e.value
    this.CalcoloQuery();
  }
  MazziniChangedList(e){
    //alert("Cambiato Lista Magazzini");
    //alert("Cambiato Selezione Magazzini"); 
    //console.log("ecco i magazzini ",this.eccoli)
    this.currentMagazzini=e.value
    this.CalcoloQuery();
  }
  CalcoloQuery(){

  }
}
